"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { ComponentConfig, CustomField } from "@measured/puck"

import { CategorySelect, CategorySelectProps } from "../../../components/CategorySelect"
import { WebsiteSelect, WebsiteSelectProps } from "../../../components/WebsiteSelect"
import { CategoryConfig } from "../../tamda-media/TamdaMediaNewsLayout/types/config"
import { NewsSwiperRenderProps, RenderConfig } from "./RenderConfig"

function NewsSwiperCategorySelect(props: CategorySelectProps) {
  const locale = useUIBuilderLocaleStore(state => state.locale)
  return <CategorySelect {...props} locale={locale} />
}

export const NewsSwiper: ComponentConfig<NewsSwiperRenderProps> = {
  label: "Tamda One | News Swiper",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    websiteDomain: {
      label: "Website Domain",
      type: "custom",
      render: props => <WebsiteSelect {...(props as WebsiteSelectProps)} />,
    } as CustomField<string>,
    categories: {
      label: "Categories",
      type: "array",
      arrayFields: {
        category: {
          label: "Category",
          type: "custom",
          render: props => <NewsSwiperCategorySelect {...(props as CategorySelectProps)} />,
        } as CustomField<CategoryConfig["category"]>,
      },
      getItemSummary: (item: CategoryConfig) =>
        item.category?.categoryName || `Category ${item.category?.categoryId || ""}`,
      defaultItemProps: {
        category: {
          categoryId: 0,
          categoryName: "",
          slug: "",
        },
      },
    },
    slidesPerView: {
      label: "Slides Per View",
      type: "number",
      min: 1,
      max: 5,
    },
    spaceBetween: {
      label: "Space Between (px)",
      type: "number",
      min: 0,
      max: 100,
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    title: "Thông tin",
    websiteDomain: "tamdagroup.eu",
    categories: [],
    slidesPerView: 3,
    spaceBetween: 20,
    className: "",
  },
  ...RenderConfig,
}
